export const url = process.env.PUBLIC_URL;
export const E_LEARNING_BASE_URL = process.env.E_LEARNING_BASE_URL ?? "/"

export const E_LEARNING_API_BASE_URL = 'https://uplatz.tech:4999/api/'
//export const E_LEARNING_API_BASE_URL = 'http://localhost:4999/api/'

export const APP_PROJECT_BASE_URL = 'http://localhost:3000'
export const APP_SERVER_BASE_URL = 'https://uplatz.tech:4999'
//export const APP_SERVER_BASE_URL = 'http://localhost:4999'

export const APP_NAME = 'E-Learning-Platform';
export const APP_DEVELOPED_BY = 'Loku-Developer';